import { getActivationCodeData } from '../../utils/api.js';
import { useCallback, useEffect, useState } from 'react';
import { ErrorCode } from '../../shared/constants/errorCodes.js';

const useActivationCodeData = (activationCode) => {
  const [activationCodeData, setActivationCodeData] = useState(null);

  const reloadActivationData = useCallback(async () => {
    try {
      const { employerName, email, languagePreference } = await getActivationCodeData(activationCode);
      setActivationCodeData({ employerName, email, languagePreference });
    } catch (e) {
      const { field, code } = e?.errors?.[0] ?? {};
      if (field === 'activationCode' && code === ErrorCode.EXPIRED_DATA) {
        setActivationCodeData({ expired: true });
      } else {
        setActivationCodeData({ invalid: true });
      }
    }
  }, [activationCode]);

  useEffect(() => {
    if (activationCode) {
      reloadActivationData();
    }
  }, [activationCode, reloadActivationData]);

  return { ...activationCodeData, reloadActivationData };
};

export { useActivationCodeData };
